import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/composables/permissions/permissions';

export const actionCentreClientRoutes = [
  {
    path: 'action-centre',
    component: () => import('./ActionCentre.vue'),
    children: [
      {
        path: '',
        name: 'client-action-centre',
        redirect: { name: 'client-action-centre-connection' },
      },
      {
        path: 'connection',
        name: 'client-action-centre-connection',
        components: {
          default: () => import('./connections/ConnectionsTab.vue'),
          sidebar: () => import('./connections/ConnectionsFilter.vue'),
        },
      },
      {
        path: 'remediation',
        name: 'client-action-centre-remediation',
        components: {
          default: () => import('./remediations/RemediationsTab.vue'),
          sidebar: () => import('./remediations/RemediationsFilter.vue'),
        },
      },
      {
        path: 'invite',
        name: 'client-action-centre-invite',
        components: {
          default: () => import('@/modules/invite/InviteListTab.vue'),
          sidebar: () => import('@/modules/invite/components/InviteFilter.vue'),
        },
        meta: {
          permissions: [Permission.ClientsInvitesView, Permission.ClientsInvitesManage],
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];

export const actionCentreSupplierRoutes = [
  {
    path: 'action-centre',
    component: () => import('./ActionCentre.vue'),
    children: [
      {
        path: '',
        name: 'supplier-action-centre',
        redirect: { name: 'supplier-action-centre-connection' },
      },
      {
        path: 'connection',
        name: 'supplier-action-centre-connection',
        components: {
          default: () => import('./connections/ConnectionsTab.vue'),
          sidebar: () => import('./connections/ConnectionsFilter.vue'),
        },
      },
      {
        path: 'remediation',
        name: 'supplier-action-centre-remediation',
        components: {
          default: () => import('./remediations/RemediationsTab.vue'),
          sidebar: () => import('./remediations/RemediationsFilter.vue'),
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];
